export const brandLogos: Record<string, string> = {
  adidas: 'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/adidas.png',
  asics: 'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/asics.png',
  carhartt:
    'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/carhartt.png',
  coleBuxton:
    'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/cole_buxton.png',
  converse:
    'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/converse.png',
  corteiz:
    'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/corteiz.png',
  fearOfGod:
    'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/fear_of_god_essentials.png',
  jordan: 'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/jordan.png',
  montirex:
    'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/montirex.png',
  newBalance:
    'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/new_balance.png',
  nike: 'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/nike.png',
  represent:
    'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/represent.png',
  stussy: 'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/stussy.png',
  theNorthFace:
    'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/the_north_face.png',
  ugg: 'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/ugg.png',
  uniqlo: 'https://cms-cdn.thesolesupplier.co.uk/bolt/assets/logos/uniqlo.png'
};
